import styled, { css } from "styled-components";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Estilos RegisterModal
Description : Se definen los estilos de los elementos del resto del formulario
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen estilos y elementos del formulario
================================================================================ */

export const FormGroup = styled.div`
    color: palevioletred;
    width: 300px;
    height: 30px;
    margin: 50px;
    margin-top: -5px;
`;

export const Form = styled.form`
    width: auto;
    padding-top: 20px;
    border-radius: 80px;
    border-color: black;
    background-color: white;
    @media screen and (max-width: 960px){
        align-content: center;
        margin-top: 50px;
    }
`;

export const Forms = styled.div`
    margin: auto;
    @media screen and (max-width: 960px){
        margin-top: 90px;
    }
`

export const Div = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    //height: 10vh;
`

export const Button = styled.button`
    background-color: #3498DB;
    color: white;
    border-radius: 8px;
    margin-bottom: 0px;
    margin-top: 30px;
    &:disabled{
        border: 1px solid #999999;
        background-color: #cccccc;
        color: #666666;
    }
`;

export const Label = styled.label`
	color: #3498DB;
    display: flex;
    margin-top: -5px;
    justify-content: flex-start;
    margin-left: 0px;
    margin-bottom: 5px;
    font-size: 14px;
    @media screen and (max-width: 960px){
        align-content: center;
        font-size: 13px;
        margin: auto;
    }
`;

export const Input = styled.input`
	padding: 0.5em;
	color: palevioletred;
	background: papayawhip;
	border: none;
	border-radius: 3px;
	width:100%;
    margin-top: -3px;
    margin-bottom: -3px;
    @media screen and (max-width: 960px){
        align-content: center;
        display: block
    }
`;

export const Image = styled.img`
    width: 40%;
    margin-top: 0.5em;
`;

export const H2 = styled.h2`
    font: 22px sans-serif;
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: center;
    position: relative;
    z-index: 1;
    &:before {
        border-top: 1px solid #1061a2;
        content: "";
        margin: 0 auto;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        bottom: 0;
        width: 75%;
        z-index: -1;
    };
    @media screen and (max-width: 960px){
        display: none;
    }
`;

export const Span = styled.span`
    background: #fff;
    padding: 0 15px;
`;

export const Select = styled.select`
    padding: 0.5em;
    color: palevioletred;
    background: papayawhip;
    border: none;
    border-radius: 3px;
    width:100%;
    margin-top: -3px;
    margin-bottom: 2px;

    option {
        color: black;
        background: white;
        display: flex;
        white-space: pre;
        min-height: 20px;
        padding: 0px 2px 1px;
      }
`;